import * as React from 'react';

import { GetStaticProps } from 'next';

import { getHeaderFooterStaticProps, HeaderFooterStaticProps } from 'cms';

import Layout from '../components/landing-pages-v2/Layout';
import { UnsubscribePage } from '../components/mail/UnsubscribePage';

const Mail: React.FC<HeaderFooterStaticProps> = ({ header, footer }) => (
  <Layout header={header ?? undefined} footer={footer ?? undefined} slug="/mail">
    <UnsubscribePage />
  </Layout>
);

export const getStaticProps: GetStaticProps<HeaderFooterStaticProps> = getHeaderFooterStaticProps;

export default Mail;
